import React from 'react';
const stats = ['+100 kant-en-klare lessen', '7 therapeutische protocollen', '5 bonussen t.w.v. €120', 'Levenslange toegang'];
export function StatsBar() {
  return <section className="border-y border-brand-creamDark bg-white/55 py-6 md:py-7" data-id="element-155" data-mp="1obf160roj5o4">
      <div className="mx-auto grid max-w-[1100px] grid-cols-2 gap-y-5 px-4 text-center md:grid-cols-4 md:gap-y-0 md:divide-x md:divide-brand-creamDark" data-id="element-156" data-mp="1od88lia49tx6">
        {stats.map(stat => <p key={stat} className="px-4 text-xs font-semibold uppercase tracking-[0.11em] text-brand-text sm:text-sm" data-id="element-157" data-mp="1efbx2pd9owyj">
            {stat}
          </p>)}
      </div>
    </section>;
}